import React from 'react';
import './QuoteItemCard.css'

const QuoteItemCard = ({
  item,
  index,
  availableItems,
  taxType,
  hasdiscount,
  onProductSelect,
  onItemChange,
  onRemoveItem,
  getItemTotal,
  calculateItemTax
}) => {
  return (
    <div className="QuoteItemCard__item-card">
      <div className="QuoteItemCard__item-header">
        <h3 className="QuoteItemCard__item-title">Item {index + 1}</h3>
        <button 
          className="QuoteItemCard__button QuoteItemCard__button--remove" 
          onClick={() => onRemoveItem(index)}
          title="Remove item"
        >
          Remove
        </button>
      </div>
      
      {/* Combined Product Selection Box */}
      <div className="QuoteItemCard__product-selection-box">
        <label className="QuoteItemCard__label">Product Selection</label>
        <div className="QuoteItemCard__product-inputs">
          <div className="QuoteItemCard__field-group QuoteItemCard__field-group--flex">
            <input
              type="text"
              placeholder="Enter product name"
              className="QuoteItemCard__input QuoteItemCard__input--product"
              value={item.product_name}
              onChange={(e) => onItemChange(index, 'product_name', e.target.value)}
            />
          </div>
          <div className="QuoteItemCard__divider">
            <span>OR</span>
          </div>
          <div className="QuoteItemCard__field-group QuoteItemCard__field-group--flex">
            <select 
              className="QuoteItemCard__select QuoteItemCard__select--product" 
              value={item.product_id} 
              onChange={(e) => onProductSelect(index, e.target.value)}
            >
              <option value="">Choose from inventory...</option>
              {availableItems.map(p => (
                <option key={p.product_id} value={p.product_id}>
                  {p.product_name} - ₹{p.price_selling}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      
      <div className="QuoteItemCard__grid-2">
        <div className="QuoteItemCard__field-group">
          <label className="QuoteItemCard__label">Quantity</label>
          <input
            type="number"
            min="1"
            className="QuoteItemCard__input"
            value={item.quantity}
            onChange={(e) => {
              const value = e.target.value;
              const numValue = value === '' ? '' : Math.max(1, parseInt(value) || 1);
              onItemChange(index, 'quantity', numValue);
            }}
          />
        </div>
        
        <div className="QuoteItemCard__field-group">
          <label className="QuoteItemCard__label">Unit Price (₹)</label>
          <input
            type="number"
            min="0"
            step="0.01"
            className="QuoteItemCard__input"
            value={item.unit_price}
            onChange={(e) => onItemChange(index, 'unit_price', parseFloat(e.target.value) || 0)}
          />
        </div>
      </div>
      
      <div className="QuoteItemCard__field-group">
        <label className="QuoteItemCard__label">Description</label>
        <textarea
          placeholder="Enter item description..."
          className="QuoteItemCard__textarea"
          value={item.description}
          onChange={(e) => onItemChange(index, 'description', e.target.value)}
        />
      </div>
      
      <div className="QuoteItemCard__grid-info">
        {taxType !== 'NONE' && (
          <div className="QuoteItemCard__info-item">
            <strong>Subtotal:</strong> ₹{getItemTotal(item).toFixed(2)}
          </div>
        )}
        {taxType !== 'NONE' && !hasdiscount && (
          <div className="QuoteItemCard__info-item">
            <strong>Tax:</strong> ₹{calculateItemTax(item).toFixed(2)}
          </div>
        )}
        <div className="QuoteItemCard__info-item QuoteItemCard__info-item--total">
          <strong>Total:</strong> ₹{(getItemTotal(item) + calculateItemTax(item)).toFixed(2)}
        </div>
      </div>
    </div>
  );
};

export default QuoteItemCard;